import { InputHTMLAttributes, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

// forwardRef is required here as react-hook-form passes a ref to
// form fields that would otherwise break function components
const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...otherProps }: InputHTMLAttributes<HTMLInputElement>, ref) => {
    return (
      <input
        className={twMerge(
          'w-full px-4 py-2 pr-4 font-light border border-primary rounded-sm focus:outline-primary placeholder:text-primary-text',
          className
        )}
        ref={ref}
        {...otherProps}
      />
    );
  }
);

// prevents linting error 'Component definition is missing display name'
Input.displayName = 'Input';

export default Input;
